import { Card, Group, Stack, Box, Text, Title } from "@mantine/core";
import { MapLibreMap } from "@mapka/react-maplibre-map";
import { MapItemControls } from "./MapItemControls";
import { ScopeBadge } from "./ScopeBadge";
import { useInViewport } from "@mantine/hooks";
import { useDefaultApiKey } from "../../../../hooks/apiKey";
import type { FC } from "react";
import type { StyleSpecification } from "@mapka/react-maplibre-map";
import type { MapItemProps } from "../types/props.js";
import { useNavigateMap } from "../hooks/navigate.js";

export const MapItem: FC<MapItemProps> = ({ style, version, account }) => {
  const apiKey = useDefaultApiKey();
  const navigate = useNavigateMap();
  const { ref, inViewport } = useInViewport();
  const {
    displayName,
    description,
    scope,
  } = style;

  const {
    spec,
  } = version;

  return (
    <Card
      ref={ref}
      p={0}
      h={300}
      onClick={() => {
        navigate(account.name, style.key);
      }}
      style={{ cursor: "pointer" }}
    >
      {/** Wrapper with fixed height so that things below don't jump once this is loaded. */}
      <Box h="66%">
        {inViewport && (
          <MapLibreMap
            apiKey={apiKey}
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            style={spec as unknown as StyleSpecification}
          />
        )}
      </Box>

      <Stack p="sm">
        <Group justify="space-between" wrap="nowrap">
          <Title order={4} style={{ flex: "1 1 0" }} lineClamp={1}>
            {displayName}
          </Title>
          <ScopeBadge scope={scope} />
        </Group>

        {description && <Text fz="sm">{description}</Text>}

        <MapItemControls
          account={account}
          style={style}
          version={version}
        />
      </Stack>
    </Card>
  );
};
